import React, { useEffect, useState } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_EQUITY } from "../../../Configuration/API_URL";
import SmallLoader from "../../Common/smallLoader";
import { Dropdown, Modal, Button, ThemeProvider } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import {
  numberFormat,
  numDifferentiation,
} from "../../../CommonMethhods/CovertRupees";
import Info from "../../../asset/images/info icon.svg";
import Loader from "../../Common/Loader";
import LoaderForSearch from "../../Common/LoaderForSearch";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

export default function ClientInFo() {
  const storeToken = localStorage.getItem("ssoToken");
  const [smallLoader, setSmallLoader] = useState(false);
  const [InFo, setInFo] = useState({});
  const [loader, setLoader] = useState(true);
  const [nakedLoader, setNakedLoader] = useState(true);
  const [aging, setAging] = useState();
  const [checkNakedResp, setCheckNakedResp] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [settlementModalShow, setSettlementModalShow] = useState(false);
  const [totalAmount, setTotalAmount] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();
  const [totalCount, setTotalCount] = useState();
  const [quarterlySettlementResp, setQuarterlySettlementResp] = useState([]);
  const [settlementLoader, setSettlementLoader] = useState(false);
  const [settlementScrollLoader, setSettlementScrollLoader] = useState(false);
  const [offset, setOffset] = useState(1);

  const getclientInFo = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getInFo = await axiosInstance.post(
        DASHBOARD_EQUITY.TodayClientInfo_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getInFo?.data);

      if (res?.data) {
        setInFo(res?.data);
        setAging(res?.data.ageing);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getNakedDebitInfo = async () => {
    // setSmallLoader(true);
    let payloadValue = { pageSize: pageSize, pageNo: page };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getNakedDebt = await axiosInstance.post(
        DASHBOARD_EQUITY.NakedDebit_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getNakedDebt?.data);
      const response = res?.data;
      setCount(response.totalCount);

      if (response) {
        // setCheckNakedResp(response);
        // setModalShow(true);
        if (modalShow === true) {
          setCheckNakedResp((prev) => {
            return [...prev, ...response.nakedDebitList];
          });
        } else {
          setCheckNakedResp(response.nakedDebitList);
        }
      }
      setNakedLoader(false);
    } catch (error) {
      console.log(error);
      setServerError("Something went wrong, Please try again later.");
    } finally {
      setSmallLoader(false);
      setNakedLoader(false);
    }
  };

  const getQuaterlySettlementInfo = async (offset) => {
    if (offset === 1) {
      setSettlementLoader(true);
    }
    let payloadValue = { limit: 10, offset };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getQuaterlySettlement = await axiosInstance.post(
        DASHBOARD_EQUITY.QuaterlySettlement_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getQuaterlySettlement?.data);
      const response = res?.data;
      setTotalCount(response.totalCount);

      if (response) {
        if (offset > 1) {
          setQuarterlySettlementResp((prev) => {
            return [...prev, ...response.quarterlySettlementInfo];
          });
        } else {
          setQuarterlySettlementResp(response.quarterlySettlementInfo);
        }
      }
    } catch (error) {
      console.error(error);
      setServerError("Something went wrong, Please try again later.");
    } finally {
      setSettlementLoader(false);
      //setSettlementScrollLoader(false);
    }
  };

  const handleScroll = (e) => {
    if (modalShow == true) {
      setPageSize(10);
      const a = document.querySelector("#nakedModel");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        if (count <= pageSize * page) {
          setScrollLoader(false);
          return;
        }
        setPage((prev) => prev + 1);
        setScrollLoader(true);
        // getNakedDebitInfo(page)
      }
    }
  };

  const handleSettlementScroll = (e) => {
    if (settlementModalShow == true) {
      const a = document.querySelector("#settlementModel");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        if (totalCount <= 10 * offset) {
          setSettlementScrollLoader(false);
          return;
        }

        setOffset((prev) => prev + 1);
        setSettlementScrollLoader(true);
        getQuaterlySettlementInfo(offset + 1);
      }
    }
  };

  const onHide = () => {
    setModalShow(false);
    setPage(1);
    setPageSize(10);
  };

  const getTotalAmount = () => {
    if (checkNakedResp) {
      const findValue = Object.values(checkNakedResp);
      if (findValue) {
        var value = 0;
        for (let i = 0; i <= findValue.length - 1; i++) {
          let newValue = Number(findValue[i].ledBal);
          value = value + newValue;
          const fixeValue = value.toFixed(2);
          setTotalAmount(fixeValue);
        }
      }
    }
  };

  function showResponse() {
    // setSmallLoader(true);
    setNakedLoader(true);
    setModalShow(true);
    getNakedDebitInfo();
  }

  useEffect(() => {
    getclientInFo();
    // getNakedDebitInfo();
  }, []);

  useEffect(() => {
    if (modalShow == true) {
      getNakedDebitInfo();
    }
  }, [page]);

  useEffect(() => {
    getTotalAmount();
  }, [checkNakedResp]);

  return (
    <div className="card-box client-box">
      <div className="card-title">
        <div className="figure-inlac">
          <h2>{Constants.Today_Client_Info}</h2>
          {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
        </div>
      </div>
      <div className="client-info-wrapper">
        <ul className="client-info-table">
          <li className="client-info-item">
            <span className="client-info-label">
              {Constants.Quarterly_Settlement}
              {smallLoader ? (
                <div className="ml-3">
                  <SmallLoader />
                </div>
              ) : (
                <button
                  className="naked-debit-button"
                  onClick={() => {
                    setSettlementModalShow(true);
                    getQuaterlySettlementInfo(1);
                    setOffset(1);
                  }}
                >
                  <span className="icon-info-icon"></span>
                </button>
              )}
            </span>
            <span 
            className={
                      InFo && InFo.qtlySettl == 0
                        ? "text-muted client-info-value"
                        : InFo.qtlySettl < 0
                        ? "red-txt client-info-value"
                        : "green-txt client-info-value"
                    }
            // className="client-info-value"
            >
              {/* 5236 */}
              {loader ? (
                // <div className="loader-alignment">
                <SmallLoader />
              ) : (
                // </div>
                <>
                   {InFo === undefined || null
                    ? "0"
                    : InFo.qtlySettl === undefined || null
                    ? "0"
                    : numDifferentiation(InFo.qtlySettl)}
                </>
              )}
            </span>
          </li>
          {/* <li className="client-info-item">
            <div className="d-flex align-items-center">
              <span className="client-info-label me-4">
                {Constants.Ageing_Debt}
              </span>
              <div className="client-info-label-select">
                <form action="/action_page.php">
                  <select
                    name="cars"
                    id="cars"
                
                  >
                    <option value="T+1">{Constants.Ageing_Debt_Tone}</option>
                    <option value="T+2">{Constants.Ageing_Debt_Ttwo}</option>
                    <option value="T+3">{Constants.Ageing_Debt_Tthree}</option>
                  </select>
                </form>
              </div>
            </div>
            <span className="client-info-value">
              {loader ? (     
                <SmallLoader />
              ) : ( 
                <div id="aging" className="aging">
                  {aging === undefined || null ? "NA" : aging["T+1"]}
                </div>
              )}
              
            </span>
          </li> */}
          <li className="client-info-item">
            <span className="client-info-label d-flex">
              {Constants.Naked_Debit}
              {smallLoader ? (
                <div className="ml-3">
                  <SmallLoader />
                </div>
              ) : (
                <button className="naked-debit-button" onClick={showResponse}>
                  <span className="icon-info-icon"></span>
                </button>
              )}
            </span>
            <span className="client-info-value">
              {loader ? (
                // <div className="loader-alignment">
                <SmallLoader />
              ) : (
                // </div>
                <>
                  <span
                    className={
                      InFo && InFo.naked == 0
                        ? "text-muted"
                        : InFo.naked < 0
                        ? "red-txt"
                        : "green-txt"
                    }
                  >
                    {/* {(InFo && InFo === undefined) || null
                      ? "0"
                      : (InFo.naked && InFo.naked === undefined) || null
                      ? "0"
                      : numDifferentiation(InFo.naked)} */}
                    {InFo.naked ? numDifferentiation(InFo.naked) : 0}
                  </span>
                </>
              )}

              {/* 5236 */}
            </span>
          </li>
          <li className="client-info-item">
            <span className="client-info-label">{Constants.Margin_Txt}</span>
            <span className="client-info-value">
              {loader ? (
                // <div className="loader-alignment">
                <SmallLoader />
              ) : (
                // </div>
                <>
                  <span
                    className={
                      InFo && InFo.margin == 0
                        ? "text-muted"
                        : InFo.margin < 0
                        ? "red-txt"
                        : "green-txt"
                    }
                  >
                    {/* {(InFo && InFo === undefined) || null
                      ? "0"
                      : (InFo.margin && InFo.margin === undefined) || null
                      ? "0"
                      : numDifferentiation(InFo.margin)} */}
                    {InFo.margin ? numDifferentiation(InFo.margin) : 0}
                  </span>
                </>
              )}
            </span>
          </li>
        </ul>
      </div>
      <Modal
        show={modalShow}
        // onHide={() => setModalShow(false)}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model naked-debit-model-wrapper"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="figure-inlac">
              <h2 className="model-title">{Constants.Naked_Debit}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            // onClick={() => setModalShow(false)}
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="setting">
            <div className="naked-debit-model table-responsive scroll-table">
              {nakedLoader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : checkNakedResp.length > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th>{Constants.Client_Ids}</th>
                      <th>{Constants.Debit_Amount}</th>
                    </tr>
                  </thead>
                  <tbody id="nakedModel" onScroll={handleScroll}>
                    {checkNakedResp.length > 0
                      ? checkNakedResp.map((element, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <a
                                  href="/client-dashboard"
                                  onClick={() => {
                                    goToClientDashboard(element.empCode);
                                    getTabStatus("");
                                  }}
                                >
                                  {element.empCode}
                                </a>
                              </td>

                              <td>
                                <span
                                  className={
                                    element.ledBal == 0
                                      ? "text-muted"
                                      : element.ledBal < 0
                                      ? "red-txt"
                                      : "green-txt"
                                  }
                                >
                                  {checkEmpty(element.ledBal)
                                    ? "-"
                                    : numDifferentiation(element.ledBal)}
                                </span>

                                {/* {element.ledBal} */}
                              </td>
                            </tr>
                          );
                        })
                      : noDataFound()}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </tbody>
                </table>
              ) : serverError ===
                "Something went wrong, Please try again later." ? (
                <h4 className="no-data">{serverError}</h4>
              ) : (
                noDataFound()
              )}

              {/* <ul className="">
                <li className="change-pwd-cont-wrapper">
                  <span className="icon-change_password setting-left-icon"></span>
                  <Link to="/changePassword">
                    <div className="change-pwd-cont">
                      <span className="setting-label">Change Password</span>
                      <span className="setting-samll-desc">
                        Set new Password
                      </span>
                    </div>
                  </Link>
                </li>

               
              </ul> */}
              {/* <div className="btn-wrapper">
              <button className="btn cancel-btn">Cancel</button>
              <button className="btn save-btn">Save</button>
            </div> */}
            </div>
            {/* <div className="setting-right-side">
            <div>

            </div>
            <div className="btn-wrapper">
              <button className="btn cancel-btn">Cancel</button>
              <button className="btn save-btn">Save</button>
            </div>
          </div> */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={settlementModalShow}
        // onHide={() => setModalShow(false)}
        onHide={() => setSettlementModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model naked-debit-model-wrapper"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="figure-inlac">
              <h2 className="model-title">{Constants.Quarterly_Settlement}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            // onClick={() => setModalShow(false)}
            onClick={() => setSettlementModalShow(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="setting">
            <div className="naked-debit-model table-responsive scroll-table">
              {settlementLoader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : quarterlySettlementResp.length > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th>{Constants.Client_Ids}</th>
                      <th>Settlement Amount</th>
                    </tr>
                  </thead>
                  <tbody id="settlementModel" onScroll={handleSettlementScroll}>
                    {quarterlySettlementResp.length > 0
                      ? quarterlySettlementResp.map((element, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {" "}
                                <a
                                  href="/client-dashboard"
                                  onClick={() => {
                                    goToClientDashboard(element.partyCode);
                                    getTabStatus("");
                                  }}
                                >
                                  {element.partyCode}
                                </a>
                              </td>
                              <td>
                                {" "}
                                <span
                                  className={
                                    element.funds == 0
                                      ? "text-muted"
                                      : element.funds < 0
                                      ? "red-txt"
                                      : "green-txt"
                                  }
                                >
                                  {checkEmpty(element.funds)
                                    ? "-"
                                    : numDifferentiation(element.funds)}
                                </span>
                              </td>
                            </tr>
                          );
                        })
                      : noDataFound()}

                    {settlementScrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </tbody>
                </table>
              ) : serverError ===
                "Something went wrong, Please try again later." ? (
                <h4 className="no-data">{serverError}</h4>
              ) : (
                noDataFound()
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
